module.exports = __webpack_public_path__ + "img/1f99c.24f1cbf.svg";